import * as yup from 'yup';
import {
  accountNumberRegex
} from '../../../constants';

export const bankDetailsValidationSchema = yup.object({
  bankName: yup.string()
    .required('Bank name is a required field'),
  accountType: yup.string()
    .required('Account Type is a required field'),
  accountNumber: yup.string().matches(accountNumberRegex, 'Account number is not valid').required('Account number is required')
});